import { createFileRoute } from "@tanstack/react-router";
import { getPersonalSourcesTitle } from "@/lib/data/personal-sources.ts";
import { StepView } from "@/components/Exercises/PersonalSources/StepView.tsx";

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/personal-sources/$step"
)({
  component: RouteComponent,
  beforeLoad: async ({ params }) => ({
    title: await getPersonalSourcesTitle(params.step, "children"),
    navbar: {
      showTitle: true,
    },
  }),
  head: () => ({
    meta: [
      {
        title: "Personal Sources of Strength - HAMD",
      },
    ],
  }),
});

function RouteComponent() {
  const params = Route.useParams();
  return <StepView audience="children" stepId={params.step} />;
}
